var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('TicketTable',{attrs:{"dev_id":_vm.dev_id,"filter_asc":_vm.filter_asc,"filter_type":_vm.filter_type,"tickets":_vm.tickets,"show_new_ticket":false},on:{"change_filter":_vm.change_filter,"change_list":_vm.change_list,"clear_list":_vm.clear_list}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }